// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__dtTFQ","imageUploader":"EGiftCard_imageUploader__3vo6q"};